import type { Ref } from 'vue';
import { nextTick, onUnmounted } from 'vue';

export function useScrollTicketListToBottom(ticketListRef: Ref<HTMLElement | null>) {
    function scrollTicketListToBottom() {
        const ticketList = ticketListRef.value;
        if (ticketList === null || typeof ticketList.scrollTo !== 'function') {
            return;
        }
        ticketList.scrollTo(0, ticketList.scrollHeight);
    }

    async function handleNewTicketAdded() {
        await nextTick();
        scrollTicketListToBottom();
    }

    window.eventEmitter.on('singleModeBetSlip:newTicketAdded', handleNewTicketAdded);

    onUnmounted(() => {
        window.eventEmitter.off('singleModeBetSlip:newTicketAdded', handleNewTicketAdded);
    });

    return {
        scrollTicketListToBottom,
    };
}
